"use client";
import { createContext, useState } from "react";

export const NearbyVenueContext = createContext({
  venueCount: 0,
  nearbyVenuesCount: 0,
  setNearbyVenuesCount: (count: number) => {},
  setVenueCount: (count: number) => {},
});

export const NearbyVenueProvider = ({ children, searchSummary }: any) => {
  const [nearbyVenuesCount, setNearbyVenuesCount] = useState(searchSummary?.nearbyVenuesCount || 0);
  const [venueCount, setVenueCount] = useState(searchSummary?.venueCount || 0);

  const value = {
    nearbyVenuesCount,
    venueCount,
    setNearbyVenuesCount,
    setVenueCount,
  };

  return (
    <NearbyVenueContext.Provider value={value}>
      {children}
    </NearbyVenueContext.Provider>
  );
};
